if (!customElements.get("facet-filters-form")) {
  customElements.define(
    "facet-filters-form",
    class FacetFiltersForm extends HTMLElement {
      constructor() {
        super();

        FacetFiltersForm.filterData = [];
        FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
        FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
        FacetFiltersForm.setListeners();
        
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
          this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector("form");
        facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
        if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
      }

      static setListeners() {
        const onHistoryChange = (event) => {
          const searchParams = event.state
            ? event.state.searchParams
            : FacetFiltersForm.searchParamsInitial;
          if (searchParams === FacetFiltersForm.searchParamsPrev) return;
          FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener("popstate", onHistoryChange);
      }

      static toggleActiveFacets(disable = true) {
        document.querySelectorAll(".js-facet-remove").forEach((element) => {
          element.classList.toggle("disabled", disable);
        });
      }

      static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById("ProductCount");
        const countContainerDesktop = document.getElementById(
          "ProductCountDesktop"
        );
        document
          .getElementById("ProductGridContainer")
          .querySelector(".collection")
          .classList.add("loading");
        if (countContainer) {
          countContainer.classList.add("loading");
        }
        if (countContainerDesktop) {
          countContainerDesktop.classList.add("loading");
        }

        sections.forEach((section) => {
          const url = `${window.location.pathname}?${searchParams}`;
          const filterDataUrl = (element) => element.url === url;

          FacetFiltersForm.filterData.some(filterDataUrl)
            ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
            : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
      }

      static renderSectionFromFetch(url, event) {
        //console.log(`renderSectionFromFetch: ${url}`);
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            FacetFiltersForm.filterData = [
              ...FacetFiltersForm.filterData,
              { html, url },
            ];
            FacetFiltersForm.renderFilters(html, event);
            FacetFiltersForm.renderProductGridContainer(html);
            FacetFiltersForm.renderProductCount(html);
          });
      }

      static renderSectionFromCache(filterDataUrl, event) {
        //console.log(`renderSectionFromCache: ${filterDataUrl}`);
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      }

      static renderProductGridContainer(html) {
        //console.log("renderProductGridContainer");
        document.getElementById("ProductGridContainer").innerHTML =
          new DOMParser()
            .parseFromString(html, "text/html")
            .getElementById("ProductGridContainer").innerHTML;
      }

      static renderProductCount(html) {
        //console.log("renderProductCount");

        // Parse the HTML string to get a document object
        const parsedHtml = new DOMParser().parseFromString(html, "text/html");

        // Select the first occurrence of .product-count in parsed HTML
        const sourceCount = parsedHtml.querySelector(".product-count__value");

        // Select the corresponding container in the current document
        const targetCounts = document.querySelectorAll(".product-count__value");

        // Update each container with the count from the parsed HTML
        targetCounts.forEach((targetCount) => {
          if (sourceCount) {
            targetCount.innerHTML = sourceCount.innerHTML;
            targetCount.classList.remove("loading"); // Remove loading class if needed
          }
        });
      }

      static renderFilters(html, event) {
        //console.log("renderFilters");
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");

        //console.log(parsedHTML)
        const facetDetailsElements = parsedHTML.querySelectorAll(
          "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
        );
        // const matchesIndex = (element) => {
        //   if (!event) return false; // Ensure event is available
          
        //   const jsFilter = event.target.closest(".js-filter");

        //   console.log(jsFilter)
          
        //   if (!jsFilter) return false; // Ensure jsFilter is found

        //   console.log(jsFilter.dataset.index)
          
        //   return element.dataset.index === jsFilter.dataset.index;
        // };

        // const facetsToRender = Array.from(facetDetailsElements).filter(
        //   (element) => !matchesIndex(element)
        // );

        // Each facet element is the contained <details> tag or a facets-form__single div
        // Loop through each and swap the details dropdown content wrapper or standalone filter for each js-filter
        facetDetailsElements.forEach((element) => {

          // Get the content of the current element
          const elementContent = element.querySelector(
            ".facets-form__content"
          ).innerHTML;

          // Select all target elements that match the data-index of the current element
          const targetElements = document.querySelectorAll(
            `#FacetFiltersForm .js-filter[data-index="${element.dataset.index}"] .facets-form__content, #FacetFiltersFormMobile .js-filter[data-index="${element.dataset.index}"] .facets-form__content`
          );

          // Loop through each target element and update its innerHTML
          targetElements.forEach((targetElement) => {
            //console.log("Updating targetElement with elementContent:", elementContent); // Log the target element being updated
            targetElement.innerHTML = elementContent;
          });
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);
      }

      static renderActiveFacets(html) {
        const activeFacetElementSelectors = [
          "#FacetFiltersForm .active-facets",
          "#FacetFiltersFormMobile .active-facets",
        ];

        activeFacetElementSelectors.forEach((selector) => {
          const activeFacetsElement = html.querySelector(selector);
          if (!activeFacetsElement) return;
          document.querySelector(selector).innerHTML =
            activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
      }

      static renderAdditionalElements(html) {
        const mobileElementSelectors = [
          "#FacetFiltersForm .facets-form__open",
          "#FacetFiltersForm .facets-form__count",
          "#FacetFiltersForm .sorting",
          "#FacetFiltersForm .facets-form__total-active",
          "#FacetFiltersFormMobile .facets-form__open",
          "#FacetFiltersFormMobile .facets-form__count",
          "#FacetFiltersFormMobile .sorting",
          "#FacetFiltersFormMobile .facets-form__total-active",
        ];

        mobileElementSelectors.forEach((selector) => {
          if (!html.querySelector(selector)) return;
          document.querySelector(selector).innerHTML =
            html.querySelector(selector).innerHTML;
        });
      }

      static updateURLHash(searchParams) {
        history.pushState(
          { searchParams },
          "",
          `${window.location.pathname}${
            searchParams && "?".concat(searchParams)
          }`
        );
      }

      static getSections() {
        return [
          {
            section: document.getElementById("product-grid").dataset.id,
          },
        ];
      }

      createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
      }

      onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll(
          "facet-filters-form form"
        );
        //const sortFilterForms = this.querySelectorAll('form');
        if (event.srcElement.className == "facets-form__checkbox") {
          //console.log("checkbox");
          const searchParams = this.createSearchParams(
            event.target.closest("form")
          );
          this.onSubmitForm(searchParams, event);
        } else {
          const forms = [];
          const isMobile =
            event.target.closest("form").id === "FacetFiltersFormDrawer";

          sortFilterForms.forEach((form) => {
            if (!isMobile) {
              if (
                form.id === "FacetSortForm" ||
                form.id === "FacetFiltersForm" ||
                form.id === "FacetSortDrawerForm"
              ) {
                const noJsElements = document.querySelectorAll(".no-js-list");
                noJsElements.forEach((el) => el.remove());
                forms.push(this.createSearchParams(form));
              }
            } else if (form.id === "FacetFiltersFormDrawer") {
              forms.push(this.createSearchParams(form));
            }
          });
          this.onSubmitForm(forms.join("&"), event);
        }
      }

      onActiveFilterClick(event) {
        //console.log("onActiveFilterClick");
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
          event.currentTarget.href.indexOf("?") == -1
            ? ""
            : event.currentTarget.href.slice(
                event.currentTarget.href.indexOf("?") + 1
              );
        FacetFiltersForm.renderPage(url);
      }
    }
  );
}

if (!customElements.get("price-range")) {
  customElements.define(
    "price-range",
    class PriceRange extends HTMLElement {
      constructor() {
        super();
        this.querySelectorAll("input").forEach((element) =>
          element.addEventListener("change", this.onRangeChange.bind(this))
        );
        this.setMinAndMaxValues();
      }

      onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
      }

      setMinAndMaxValues() {
        const inputs = this.querySelectorAll("input");
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute("max", maxInput.value);
        if (minInput.value) maxInput.setAttribute("min", minInput.value);
        if (minInput.value === "") maxInput.setAttribute("min", 0);
        if (maxInput.value === "")
          minInput.setAttribute("max", maxInput.getAttribute("max"));
      }

      adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute("min"));
        const max = Number(input.getAttribute("max"));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
      }
    }
  );
}

if (!customElements.get("facet-remove")) {
  customElements.define(
    "facet-remove",
    class FacetRemove extends HTMLElement {
      constructor() {
        super();
        const facetLink = this.querySelector("a");
        facetLink.setAttribute("role", "button");
        facetLink.addEventListener("click", this.closeFilter.bind(this));
        facetLink.addEventListener("keyup", (event) => {
          event.preventDefault();
          if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
        });
      }

      closeFilter(event) {
        event.preventDefault();
        const form =
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
      }
    }
  );
}
